module.exports = __webpack_public_path__ + "img/kovalenko.69da3d46.png";